
export enum RateRequestSubTypeCd {
	GUAR_FAIL = 'GuarFail',
	GUAR_NOSA = 'GuarNosa',
	WRNT_FAIL = 'WrntFail'}

